import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { MathBlock } from "../components/MathRender";
import { ShieldCheck, FileText } from "lucide-react";

export default function Verify() {
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    api.get("/verify/queue").then((r) => setQueue(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-5 py-12 sm:px-8" data-testid="verify-page">
      <p className="eyebrow mb-2">Verify</p>
      <h1 className="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl flex items-center gap-3">
        <ShieldCheck className="h-8 w-8 text-[#E61A27]" /> Independent Review Queue
      </h1>
      <p className="mt-3 max-w-2xl text-slate-500">
        Two independent reviews decide paid acceptance. Your honorarium is fixed and never depends on your verdict.
      </p>

      <div className="mt-10 space-y-4">
        {queue.map((s) => (
          <Link to={`/submissions/${s.id}`} key={s.id} data-testid={`queue-item-${s.id}`} className="axiom-card block p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <FileText className="h-5 w-5 text-[#E61A27]" />
                <div>
                  <p className="text-sm text-slate-900">{s.problem_title}</p>
                  <p className="text-xs text-slate-500">by {s.contributor_name} · v{s.version} · {s.reviews?.length || 0}/2 reviews</p>
                </div>
              </div>
              <span className="btn-ghost !px-4 !py-2 text-sm">Review</span>
            </div>
            <div className="mt-4 opacity-80"><MathBlock>{s.content_latex}</MathBlock></div>
          </Link>
        ))}
        {queue.length === 0 && <p className="text-slate-500" data-testid="queue-empty">No submissions awaiting your review.</p>}
      </div>
    </div>
  );
}
